<!-- src/components/ParkingModal.vue -->
<template>
  <div class="modal-content">
    <div class='park-photo-div'>
      <img :src="getFullImageURL(parking.photo_url)" alt="Parking Lot" @error="onImageError" />
      <span class="close" @click="closeModal">&times;</span>
      <!-- Navigation Icon -->
      <div class="navigation-icon" @click="onNavigateClick">
        <i class="fas fa-location-arrow"></i> <!-- Font Awesome icon -->
      </div>
    </div>
    <h3>{{ parking.title }}</h3>
    <div class="park-type-line">
      <!-- <div class="park-num">{{ parking.total_space }} 個車位</div> -->
      <!-- <div class="park-type">{{ getParkingType(parking) }}</div> -->
      <!-- <div class="park-type" v-for="">{{ getParkingType(parking) }}</div> -->
      <div class="park-type" v-for="(type, index) in getParkingType(parking)" :key="index">
        {{ type }}
      </div>
    </div>
    <label>地址</label>
    <p>{{ paddingBlank(parking.address) }}</p>
    <!-- 場地限高：無值不顯示（247 個場站中 166 個未填） -->
    <!-- anti-max-height 供窄螢幕、max-height 供寬螢幕，由 CSS 切換 -->
    <div class="anti-max-height" v-if="hasMaxHeight">
      <label>場地限高</label>
      <p class="max-height-value">{{ parking.max_height }}M</p>
    </div>
    <div class="max-height" v-if="hasMaxHeight">
      <label>場地限高</label>
      <p class="max-height-value">{{ parking.max_height }}M</p>
    </div>
    <!-- 臨停費率：功能開關開啟、場站啟用臨停、且已填寫費率說明時才顯示 -->
    <div v-if="tempRates.length" class="temp-rate">
      <label>臨停費率</label>
      <div class="rate-lines">
        <p class="rate-line" v-for="(line, index) in tempRates" :key="index">{{ line }}</p>
      </div>
      <p class="rate-disclaimer">費率僅供參考,如有爭議<br>最終請依現場告示費率牌為準</p>

      <!-- 月票牌價：Depid 帶入該場站編號 -->
      <a
        v-if="parking.parking_id"
        class="rate-link"
        :href="'https://webrent.taiwan-parking.com.tw/WebRentCS/WebRentcs.aspx?Depid=' + parking.parking_id"
        target="_blank"
        rel="noopener noreferrer"
        @click="onRateLinkClick"
      >月票牌價(請點我)</a>
    </div>

    <!-- 特約商店：無值不顯示 -->
    <template v-if="hasPartnerStore">
      <label>特約商店</label>
      <p>{{ parking.partner_store }}</p>
    </template>
    <label>支付方式</label>
    <!-- <p>{{ parking.payment_method }}</p> -->
    <p>{{ getPaymentMethod(parking) }}</p>
    <div class="payment-buts">
      <button class='payment-but' @click="proceedToPayment">線上繳費</button>
      <button v-if="parking.is_rent" class='payment-but monthly-rental-but' @click="applyMonthlyRental">申請月租</button>
    </div>
  </div>
</template>

<script>
import { onImageError, getParkingType, getPaymentMethod, getFullImageURL, paddingBlank, getTempRates, logWebClick } from '@/util/util';
import { navigateToParking } from '@/util/map';

export default {
  name: 'ParkingModal',
  props: {

    parking: {
      type: Object,
      required: true
    }
  },
  computed: {
    // 空陣列代表整區不顯示（功能未開啟、場站未啟用臨停、或無費率資料）
    tempRates() {
      return getTempRates(this.parking);
    },

    hasMaxHeight() {
      const v = this.parking.max_height;
      return v !== null && v !== undefined && v !== '';
    },

    hasPartnerStore() {
      const v = this.parking.partner_store;
      return v !== null && v !== undefined && String(v).trim() !== '';
    }
  },
  methods: {
    paddingBlank,
    getPaymentMethod,
    navigateToParking,
    getFullImageURL,
    onImageError,
    getParkingType,
    closeModal() {
      this.$emit('close');
    },

    // 點擊行為記錄：連結本身照常開啟（target=_blank，原頁不動，fetch 一定送得完）
    onRateLinkClick() {
      logWebClick('web_rate_click', this.parking);
    },

    onNavigateClick() {
      logWebClick('web_nav_click', this.parking);
      // navigateToParking 內部使用 this.parking，維持原本的 this 綁定呼叫
      return navigateToParking.call(this);
    },
    proceedToPayment() {
      this.$emit('proceed');
    },
    applyMonthlyRental() {
      // this.$emit('monthlyRental');
      //goto UserApply page
      this.$router.push({ name: 'UserApply', params: { parking_id: this.parking.id } });
    }
  }
};
</script>

<style scoped>
.modal-content {
  position: absolute;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
  align-items: left;
  text-align: left;
  justify-content: center;
  margin: 0 auto;
  /* margin: 10% auto; */
  /* top:397px; */
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #888;
  width: 440px;
  /* height: 640px; */
  box-sizing: border-box;

  /* top: 397.25px; */
}



.park-photo-div {
  position: relative;
  width: 408px;
  height: 200px;
  /* top: 16px; */
  /* left: 16px; */
  border-radius: 12px;

}

.park-photo-div img {
  width: 100%;
  height: 100%;

  border-radius: 12px;

  object-fit: cover;
  /* Ensures the image covers the container, cropping as needed */

}


.close {
  position: absolute;
  top: 8px;
  /* Positioning near the top-right corner of the image */
  right: 8px;
  background-color: white;
  /* Semi-transparent gray background */
  color: black;

  font-weight: 100;
  font-size: 24px;
  font-weight: bold;
  padding: 4px 8px;
  /* Padding around the "X" */
  border-radius: 50%;
  /* Makes it a circle */
  cursor: pointer;
  text-align: center;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}


.navigation-icon {
  position: absolute;
  bottom: -80px;
  right: 8px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--green03);
  /* Adjust to match your theme */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.navigation-icon i {
  color: white;
  /* Icon color */
  font-size: 20px;
  /* Adjust icon size */
}

.navigation-icon:hover {
  transform: scale(1.1);
  /* Hover effect */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  /* Enhanced shadow on hover */
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  50% {
    transform: scale(1.15);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
}

.navigation-icon {
  animation: pulse 1.5s infinite ease-in-out;
  /* Pulsing animation */
}


h3 {
  margin-top: 12px;
  margin-bottom: 0px;
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: left;

  color: var(--gray15);
}

.park-type-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* margin-top: 12px; */
}

.park-num {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;
  text-align: left;

  color: var(--green03);
}


.park-type {

  padding: 4px 6px 4px 6px;

  /* margin-left: 10px; */
  margin-right: 10px;

  font-family: Inter;
  font-size: 12px;
  font-weight: 700;
  line-height: 18.48px;
  text-align: left;



  border-radius: 8px;

  background-color: var(--green05);
  color: white;
}


.modal-content label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 18.48px;
  text-align: left;


  margin-top: 10px;

  color: var(--gray11);
}

/* 場地限高：與費率免責同色，屬提醒性資訊 */
.modal-content .max-height-value {
  color: #c0392b;
}

/* ---- 臨停費率 ---- */
.temp-rate {
  margin-top: 10px;
}

/* 時段多的場站（最多 12 行）在區塊內捲動，避免把下方按鈕推出畫面 */
.temp-rate .rate-lines {
  max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.temp-rate label {
  margin-top: 0;
}

.temp-rate .rate-line {
  font-size: 16px;
  color: var(--gray15);
  margin: 2px 0 0;
  line-height: 1.6;
}

.temp-rate .rate-disclaimer {
  font-size: 12px;
  color: #c0392b;
  line-height: 1.55;
  margin-top: 8px;
}

.temp-rate .rate-link {
  display: inline-block;
  margin-top: 8px;
  font-size: 15px;
  font-weight: 500;
  color: var(--green03);
  text-decoration: underline;
}

.temp-rate .rate-link:hover {
  color: var(--green05);
}

.modal-content p {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;

  color: var(--gray13);
  margin-top: 2px;
  margin-bottom: 4px;

}



.payment-but {
  margin-top: 38px;
  border: none;
  cursor: pointer;
  width: 100%;

  width: 408px;
  height: 58px;
  min-height: 48px;
  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;



  background-color: var(--green03);
  color: white;

  margin-top: 12px;

}

.monthly-rental-but {
  background-color: white;
  color: var(--green03);
  border: 1px solid var(--green03);
}


.anti-max-height {
  display: none;
}

@media screen and (max-width: 560px) {


  .modal-content {
    width: 375px;
    margin: 0px auto;
    /* margin:0px; */
    /* padding: 12.5px; */
    padding: 16px;
  }

  .modal-content label {

    margin-top: 4px;
  }

  .park-photo-div {
    width: 343px;
    height: 200px;
  }

  .park-photo-div img {
    width: 100%;
    height: 100%;
  }

  .close {
    top: 8px;
    right: 8px;
  }


  .payment-buts {
    display: flex;

    flex-direction: row-reverse;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 0px;
    align-items: center;
  }

  .max-height {
    display: none;

  }

  .anti-max-height {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    margin-right:20px;
  }

  .payment-but {

    margin-top: 0px;
    width: 100%;

  }

}
</style>